import { useState, useEffect, useCallback } from "react"
import PropTypes from "prop-types"

import classNames from "classnames"
import UpgradeToProModal from "./upgrade_to_pro_modal"

const PlanUpgradeButton = ({
  buttonOnColor,
  currentTier,
  eligibleForTrial,
  newProPlusSubscriptionUrl,
  proPlusProductId,
  subscriptionPaymentType,
  isTrialing,
  trackLocationType,
  upgradePath,
}) => {
  const upgrading = !!window.App.userId && currentTier !== "free"
  const [showModal, setShowModal] = useState(false)

  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  }, [showModal])

  useEffect(() => {
    const erbOverlay = document.querySelector(".link_overlay.js-handle")

    if (erbOverlay) {
      erbOverlay.addEventListener("click", toggleModal)

      return () => erbOverlay.removeEventListener("click", toggleModal)
    }
  }, [toggleModal])

  const cta = eligibleForTrial ? "Try it free" : "Get Pro+"

  return (
    <>
      {upgrading && (
        <UpgradeToProModal
          visible={showModal}
          step="plan_upgrade"
          {...{
            currentTier,
            eligibleForTrial,
            proPlusProductId,
            subscriptionPaymentType,
            isTrialing,
            trackLocationType,
          }}
          onClose={() => toggleModal()}
          onUpgrade={() => (window.location = upgradePath)}
        />
      )}
      <a
        href={upgrading ? undefined : newProPlusSubscriptionUrl}
        onClick={upgrading ? () => toggleModal() : undefined}
        className={classNames("button-tertiary", {
          "button-on-color": buttonOnColor,
        })}
        data-turbolinks="false"
        title={cta}
      >
        {cta}
      </a>
    </>
  )
}

PlanUpgradeButton.propTypes = {
  buttonOnColor: PropTypes.bool,
  currentTier: PropTypes.string,
  eligibleForTrial: PropTypes.bool,
  newProPlusSubscriptionUrl: PropTypes.string.isRequired,
  proPlusProductId: PropTypes.string.isRequired,
  subscriptionPaymentType: PropTypes.string,
  isTrialing: PropTypes.bool,
  trackLocationType: PropTypes.string,
  upgradePath: PropTypes.string,
}

PlanUpgradeButton.defaultProps = {
  buttonOnColor: false,
}

export default PlanUpgradeButton
